import * as React from 'react';

import { DropdownSelect } from '../../global/components/inputs/selects/dropdown-select'
import { IDropdownOption } from '../../global/state-helpers/filters';
import { IKeyValuePair } from '../models/key-value-pair';

interface IProps {
    // Text properties
    title: string;
    editLabel: string;
    cancelLabel: string;
    selectLabel: string;
    selectPrompt: string;
    saveLabel: string;

    // Create new stuff
    addNewLabel: string;
    addNewUrl: string;

    // Actual options to select
    options: IKeyValuePair[];
    selectedOption: string;

    // Notify parent we've made a selection
    onOptionSaved: (option: string) => Promise<void>;
}

interface IState {
    editing: boolean;
    dropdownOptions: IDropdownOption[]
}

export class ToggleableSelect extends React.Component<IProps, IState> {
    state: IState = {
        editing: false,
        dropdownOptions: this.props.options.map(kvp => ({
            id: kvp.key,
            display: kvp.value,
            selected: kvp.key === this.props.selectedOption
        })),
    }

    render() {

        const { title, selectedOption, editLabel, cancelLabel } = this.props;
        const { editing } = this.state;

        return (
            <div>
                <div className="my-account-section-item">
                    <div className="my-account-section-item-label">{title}</div>
                    {!editing && this.renderStatic()}
                    <div className="my-account-section-item-edit" onClick={this.onEditToggle}>
                        {editing ? cancelLabel : editLabel}
                    </div>
                </div>
                {editing && this.renderEditor()}
            </div>
        );
    }

    renderStatic = () => {
        const { selectedOption, options } = this.props;

        const option = options.filter(o => o.key === selectedOption)[0];
        const display = option ? option.value : '';

        return (
            <div className="my-account-section-item-value">{display}</div>
        )
    }

    renderEditor = () => {
        return (
            <div className="my-account-section-editSection">
                <DropdownSelect
                    values={this.state.dropdownOptions}
                    display={this.props.selectLabel}
                    placeHolder={this.props.selectPrompt}
                    onDropdownSelect={this.onDropdownSelect} />
                <a href={this.props.addNewUrl}> { this.props.addNewLabel } </a>
                <div className="button-wrapper">
                    <a className="my-account-section-editSection-save button-primary" onClick={this.onSave}>
                        {this.props.saveLabel}
                    </a>
                </div>
            </div>
        )
    }

    onEditToggle = () => {
        this.setState({
            editing: !this.state.editing,
            dropdownOptions: this.props.options.map(kvp => ({
                id: kvp.key,
                display: kvp.value,
                selected: kvp.key === this.props.selectedOption
            }))
        })
    }

    onDropdownSelect = (value: string) => {
        this.setState({
            dropdownOptions: this.props.options.map(kvp => ({
                id: kvp.key,
                display: kvp.value,
                selected: kvp.key === value
            }))
        })
    }

    onSave = () => {
        const selected = this.state.dropdownOptions.filter(o => o.selected)[0];
        if (!selected) {
            // They selected the placeholder, show error?
            console.warn('No option was selected on save press');
            return;
        }
        this.props.onOptionSaved(selected.id)
            .then(() => this.setState({ editing: false }))
            .catch(err => console.warn(err));
    }
}